import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../../hooks/useCountdown';
interface CountdownPillProps {
  tone?: 'light' | 'dark' | 'bare';
  label?: string;
}
export function CountdownPill({
  tone = 'light',
  label = 'Launch price ends in'
}: CountdownPillProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const toneClasses = tone === 'dark' ? 'bg-sun/15 text-sun ring-sun/30' : tone === 'bare' ? 'text-ink/60' : 'bg-sun/30 text-ink ring-ink/10';
  return <p className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-center text-[9px] font-black uppercase leading-tight tracking-[0.1em] sm:px-3.5 sm:text-[10px] sm:tracking-[0.12em] ${tone === 'bare' ? '' : 'ring-1'} ${toneClasses}`} data-id="element-252" data-mp="12bxlp4byavvo">
      <ClockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-253" data-mp="1c2jw8k4t8w7i" />
      {label}
      <span className="tabular-nums tracking-[0.06em]" data-id="element-254" data-mp="el1p7twjvci3">
        {hours}:{minutes}:{seconds}
      </span>
    </p>;
}